// <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 1.5C0.25 1.10218 0.408035 0.720644 0.68934 0.43934C0.970644 0.158035 1.35218 0 1.75 0H5.899C6.11886 8.24403e-05 6.33601 0.0484955 6.53509 0.141812C6.73416 0.235128 6.91029 0.371065 7.051 0.54L8.476 2.25H0.25V1.5ZM0.25 3.75V11.25C0.25 11.6478 0.408035 12.0294 0.68934 12.3107C0.970644 12.592 1.35218 12.75 1.75 12.75H12.25C12.6478 12.75 13.0294 12.592 13.3107 12.3107C13.592 12.0294 13.75 11.6478 13.75 11.25V3.75H0.25Z" fill="#3E90F0"/>
import React from "react";
import { SvgProps } from "../types";

export const FileIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 14 13"
      className={props.classNames?.join(" ") || ""}
    >
      <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M0.25 1.5C0.25 1.10218 0.408035 0.720644 0.68934 0.43934C0.970644 0.158035 1.35218 0 1.75 0H5.899C6.11886 8.24403e-05 6.33601 0.0484955 6.53509 0.141812C6.73416 0.235128 6.91029 0.371065 7.051 0.54L8.476 2.25H0.25V1.5ZM0.25 3.75V11.25C0.25 11.6478 0.408035 12.0294 0.68934 12.3107C0.970644 12.592 1.35218 12.75 1.75 12.75H12.25C12.6478 12.75 13.0294 12.592 13.3107 12.3107C13.592 12.0294 13.75 11.6478 13.75 11.25V3.75H0.25Z" />
    </svg>
  );
};